import styled from "styled-components";
import { TextField } from "@mui/material";
import { mainFont, white } from "../../utils/StyleHelpers";

export const StyledSearchBar = styled.div`
  display: flex;
  width: 35%;
  height: auto;
  align-items: center;
  gap: 1rem;
  border-radius: 0.5rem;
  background: rgba(0, 0, 0, 0.1);
`;

export const StyledSearchInput = styled(TextField)({
  flex: "1 0 0",
  "& .MuiOutlinedInput-root": {
    color: white,
    fontFamily: mainFont,
    fontSize: "1.25rem",
    fontWeight: 300,
    lineHeight: "normal",
    "& ::placeholder": {
      color: white,
      fontFamily: mainFont,
      fontSize: "1.25rem",
      fontWeight: 300,
      lineHeight: "normal",
      opacity: 1,
    },
    "& fieldset": {
      borderColor: "transparent",
    },
    "&:hover fieldset": {
      borderColor: "#B2BAC2",
    },
    "&.Mui-focused fieldset": {
      borderColor: white,
    },
  },
});
